(() => {
    'use strict';

    angular
        .module('cog.shared')
        .service('PendingWagerTransformer', PendingWagerTransformer);

    /* @ngInject */
    function PendingWagerTransformer(BET_TYPES, $window) {
        var service: IPendingWagerTransformer = {
            transformList: (data: PendingList) => {
                if (data.Items.length > 0) {
                    data.TotalRisk = 0;
                    data.TotalWin = 0;
                    angular.forEach(data.Items, function (pending, idx) {
                        pending.IsRR = pending.Wagers.length > 1 ? true : false;
                        pending.TotalRRRisk = 0;
                        pending.TotalRRWin = 0;

			            if (pending.IsRR) {
                            // RR
                            pending.expandRR = false;
                            pending.RRLoaded = false; // UI use
                            pending.showRRLoading = false; // UI use
                        }
                        
                        $window._.forEach(pending.Wagers, function (pitm: PendingItem, key) {
                            data.TotalRisk += pitm.TotalRisk;
                            data.TotalWin += pitm.TotalWin;
                            pending.Wagers[key] = transformPendingItem(pitm);

                            if (pending.IsRR) {
                                pending.TotalRRRisk += pitm.TotalRisk;
                                pending.TotalRRWin += pitm.TotalWin;
                                // RR UI use only
                                pitm._RRId = 'wager-rr-'+pitm.WagerNumber+'-'+pitm.TicketNumber;
                            }
                        });
                    });
                }
                return data;
            },
            transformItem: (data: PendingItem) => {
                return transformPendingItem(data);
            },
            getFillSpotServiceData: (data: PendingItem) => {
                return { TicketNumber: data.TicketNumber, WagerNumber: data.WagerNumber };
            },
            transformOpenBetDetail: (data: BetOpenCard) => {
                var openBetDtl: OpenBetDetail = new OpenBetDetail();
                openBetDtl.$window = $window;
                openBetDtl.format(data);
                // remove line changes items from BetItems
                if (openBetDtl.hasLineChangesErr()) {
                    var betItems = $window._.map(openBetDtl.BetItems, function (item) {
                        return item.Id
                    });
                }
                return openBetDtl;
            }
        };

        function transformPendingItem(data: PendingItem) {
            data.isOpenWager = (data.Outcome.toLowerCase() == 'open') ? true : false;
            data.WagerType = getWagerType(data.Type);
            data.openSpots = 0;
            data.PendingType = getPendingItemTypeData(data.Details);
            if (data.Details.length > 0) {
                $window._.forEach(data.Details, function (pidtl: PendingItemDetail, key) {
                    data.Details[key].isOpen = (pidtl.Description.toLocaleLowerCase() == "open spot") ? true : false;
                    if (data.Details[key].isOpen)
                        data.openSpots++;
                    if (data.Details[key].Description.toLowerCase().indexOf("win game") >= 0 || data.Details[key].Description.toLowerCase().indexOf("wins game") >= 0) {
                        data.Details[key].PeriodDescription = "Game";
                    }
                });
            }
            return data;
        }

        function getPendingItemTypeData(wagerDetails: PendingItemDetail[]): IPendingItemType {
            let itemData: IPendingItemType = {
                Desc: "",
                ShortDesc: "",
                QtyType: 0
            };
            let pTypes: number[] = [];
            if (wagerDetails != null && wagerDetails.length > 0) {
                $window._.forEach(wagerDetails, function (pidtl: PendingItemDetail, key) {
                    if (wagerDetails[key].PendingType != null && wagerDetails[key].PendingType >= 0) {
						let isOpen = (pidtl.Description.toLocaleLowerCase() == "open spot") ? true : false;
                        if (!isOpen)
							pTypes.push(wagerDetails[key].PendingType);
                    }
                });
                if (pTypes.length > 0) {
                    pTypes = $window._.uniq(pTypes);
                    itemData.QtyType = pTypes.length;
                    let _DescList: string[] = [];
                    let _ShortDescList: string[] = [];
                    pTypes = $window._.orderBy(pTypes);
                    $window._.forEach(pTypes, function (ptype: number, key) {
                        _DescList.push(WagerPendingType.GetDesc(ptype));
                        _ShortDescList.push(WagerPendingType.GetDesc(ptype, true));
                    });
                    itemData.Desc = $window._.join(_DescList, ",");
                    itemData.ShortDesc = $window._.join(_ShortDescList, ",");
                }
            }
            return itemData;
        }

        function getWagerType(t: string) {
            // need to check it this way since service send a text and is diff than from BET_TYPES desc
            var _tp: string = null;
            switch (t) {
                case "Straight":
                    _tp = BET_TYPES.S.type;
                    break;
                case "Event":
                    _tp = BET_TYPES.E.type;
                    break;
                case "Parlay":
                    _tp = BET_TYPES.P.type;
                    break;
                case "Teaser":
                    _tp = BET_TYPES.T.type;
                    break;
                case "If Bet":
                    _tp = BET_TYPES.I.type;
                    break;
                case "Action Reverse":
                    _tp = BET_TYPES.A.type;
                    break;
                case "PropFecta":
                    _tp = BET_TYPES.B.type;
                    break;
            }
            return _tp;
        }
        return service;
    }
})();

class WagerPendingType {
    public static TYPE_ALL: number = -1;
    public static TYPE_IN_GAME: number = 0;
    public static TYPE_TODAY: number = 1;
    public static TYPE_LATER: number = 2;
    public static TYPE_FUTURES: number = 3;

    public static GetDesc(ptId: number, short: boolean = false): string {
        let _desc: string = "";
        switch (ptId) {
            case WagerPendingType.TYPE_ALL:
                _desc = "ALL";
                break;
            case WagerPendingType.TYPE_IN_GAME:
                _desc = (!short) ? "IN GAME" : "GM";
                break;
            case WagerPendingType.TYPE_TODAY:
                _desc = (!short) ? "TODAY" : "TD";
                break;
            case WagerPendingType.TYPE_LATER:
                _desc = (!short) ? "LATER" : "LTR";
                break;
            case WagerPendingType.TYPE_FUTURES:
                _desc = (!short) ? "FUTURES" : "FUT";
                break;
        }
        return _desc;
    }
}

class OpenBetDetail implements IOpenBetDetail {
    TicketNumber: number;
    IdTeaser: number;
    WagerNumber: number;
    OpenSpots: number;
    Risk: number;
    Win: number;
    TotalPicks: number;
    BetType: string;
    BetItems: BetDetail[];
    Errs: any;
    HasErrs: boolean = false;
    BetErrs: any[] = Array<any>();
    ItemsErrs: any[] = Array<any>();
    LinesErrs: any[] = Array<any>();
    $window = null;

    format(data: BetOpenCard) {
        this.TicketNumber = data.TicketNumber;
        var BetData: BetOpenHeader = data.Bets[0];
        this.IdTeaser = BetData.IdTeaser;
        this.WagerNumber = data.WagerNumber;
        this.OpenSpots = BetData.OpenSpots;
        this.Risk = BetData.Risk;
        this.Win = BetData.Win;
        this.TotalPicks = BetData.TotalPicks;
        this.BetType = BetData.BetType;
        this.BetItems = Array<BetDetail>();

        if (BetData.BetItems.length > 0) {
            for (var BetItem of BetData.BetItems) {
                var item: BetDetail = BetItem as BetDetail;
                this.BetItems.push(item);
            }
        }
        // set errs
        this.Errs = BetData.Errors;
        this.HasErrs = (this.hasBetErr() || this.hasItemsErr() || this.hasLineChangesErr()) ? true : false;
        if (this.hasBetErr()) {
            this.BetErrs = this.getBetErrs();
        }
        if (this.hasItemsErr()) {
            for (var itemErr of this.getItemsErrs()) {
                var err: any = itemErr;
                if (this.ItemsErrs[err.Id] == null)
                    this.ItemsErrs[err.Id] = Array<string>();
                var idx = this.$window._.findIndex(this.ItemsErrs[err.Id], function (o) {
                    return o.desc == err.Description;
                });
                if (idx === -1)
                    this.ItemsErrs[err.Id].push({ desc: err.Description });
            }
        }
        if (this.hasLineChangesErr()) {
            for (var lcErr of this.getLineChangesErrs()) {
                var err: any = lcErr;
                if (this.LinesErrs[err.PreviousId] == null)
                    this.LinesErrs[err.PreviousId] = Array<{}>();
                this.LinesErrs[err.PreviousId] = { newId: err.Id, autoAccepted: err.AutoAccepted };
            }
        }
    }

    hasBetErr(): boolean {
        return (this.Errs.Bet.length > 0) ? true : false;
    }
    hasItemsErr(): boolean {
        return (this.Errs.Items.length > 0) ? true : false;
    }
    hasLineChangesErr(): boolean {
        //return (this.Errs.LineChanges.length > 0) ? true : false;        
        var hasErr = false;
        for (var lcErr of this.getLineChangesErrs()) {
            if (!lcErr.AutoAccepted)
                hasErr = true;
        }
        return hasErr;
    }
    getBetErrs(): any[] {
        return this.Errs.Bet;
    }
    getItemsErrs(): any[] {
        return this.Errs.Items;
    }
    getLineChangesErrs(): any[] {
        return this.Errs.LineChanges;
    }
    getLineChangeErrById(id: string) {
        return (this.LinesErrs[id] != null && this.LinesErrs[id] != undefined) ? this.LinesErrs[id] : null;
    }
    getItemErrById(id: string): string {
        //return (this.ItemsErrs[id] != null && this.ItemsErrs[id] != undefined) ? this.ItemsErrs[id].Description : null;
        return (this.ItemsErrs[id] != null && this.ItemsErrs[id] != undefined) ? this.ItemsErrs[id] : null;
    }
    hasLineChange(id: string): boolean {
        var errData = this.getLineChangeErrById(id);
        return (errData != null) ? true : false;
    }
    getLineChangeNewId(id: string): string {
        var errData = this.getLineChangeErrById(id);
        return (errData != null) ? errData.newId : '';
    }
    swapLineChangesErrId(oldId: string, newId: string): any {
        delete this.LinesErrs[oldId];
        this.LinesErrs[newId] = Array<{}>();
        this.LinesErrs[newId] = { newId: oldId, autoAccepted: true };
    }
    // testing
    /*
    hasBetErr(): boolean {
        return true; //test
    }
    hasItemsErr(): boolean {
        return true;
    }
    hasLineChangesErr(): boolean {
        return true;
    }
    getBetErrs(): any[] {
        var arr = new Array();
        arr.push({ Description: 'err_1' });
        arr.push({ Description: 'err_2' });
        arr.push({ Description: 'err_3' });
        return arr;//test
    }
    getItemsErrs(): any[] {
        return this.Errs.Items;
    }
    getLineChangesErrs(): any[] {
        return this.Errs.LineChanges;
    }
    getLineChangeErrById(id: string) {
        return (this.LinesErrs[id] != null && this.LinesErrs[id] != undefined) ? this.LinesErrs[id] : null;
    }
    getItemErrById(id: string): string {
        return "Test Error"; // test
    }
    hasLineChange(id: string): boolean {
        var errData = this.getLineChangeErrById(id);
        return true; // test
    }
    getLineChangeNewId(id: string): string {
        var errData = this.getLineChangeErrById(id);
        return (errData != null) ? errData.newId : id; // test
    }
    */
}